import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { AgentApiCandidateMailsShow } from '@/types/serializers';

export default function useCancelCandidateMail() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement)?.content ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (mailId: number): Promise<AgentApiCandidateMailsShow> => {
      const response = await fetch(`/agent/api/candidate_mails/${mailId}/cancel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        let message = 'キャンセルに失敗しました。';
        try {
          const data = await response.json();
          const serverMessage = data?.error ?? data?.message ?? data?.errors?.[0];
          if (typeof serverMessage === 'string' && serverMessage.trim().length > 0) {
            message = serverMessage;
          }
        } catch (error) {
          console.error(error);
        }
        throw new Error(message);
      }

      return await response.json();
    },
    onSettled: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ['candidateMails'] }),
        queryClient.invalidateQueries({ queryKey: ['candidateMail'] }),
      ]),
  });
}
